/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/sections/opk-search.js":
/*!********************************************!*\
  !*** ./src/scripts/sections/opk-search.js ***!
  \********************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

eval("{__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _styles_sections_opk_search_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../styles/sections/opk-search.scss */ \"./src/styles/sections/opk-search.scss\");\n\nconst SELECTORS = {\n  searchInput: '.js-opk-search-input',\n  searchIcon: '.js-opk-search-btn-search',\n  closeIcon: '.js-opk-search-btn-close'\n};\nconst handleSearchIcons = () => {\n  const $searchInputs = document.querySelectorAll(SELECTORS.searchInput);\n  if (!$searchInputs.length) return;\n  $searchInputs.forEach($searchInput => {\n    const $parentSearch = $searchInput.parentElement;\n    if (!$parentSearch) return;\n    const $iconSearch = $parentSearch.querySelector(SELECTORS.searchIcon);\n    if (!$iconSearch) return;\n    const $iconClose = $parentSearch.querySelector(SELECTORS.closeIcon);\n    if (!$iconClose) return;\n    $iconClose.addEventListener('click', () => {\n      const form = $searchInput.closest('form');\n      if (!form) return;\n      $searchInput.value = '';\n      form.submit();\n    });\n    const handelClass = input => {\n      if (input.value == '') {\n        $iconSearch.classList.remove('hidden');\n        $iconClose.classList.add('hidden');\n      } else {\n        $iconSearch.classList.add('hidden');\n        $iconClose.classList.remove('hidden');\n      }\n    };\n    handelClass($searchInput);\n    $searchInput.addEventListener('click', e => {\n      handelClass(e.target);\n    });\n  });\n};\ndocument.addEventListener('DOMContentLoaded', () => {\n  handleSearchIcons();\n});\n\n//# sourceURL=webpack://trendmodenl/./src/scripts/sections/opk-search.js?\n}");

/***/ }),

/***/ "./src/styles/sections/opk-search.scss":
/*!*********************************************!*\
  !*** ./src/styles/sections/opk-search.scss ***!
  \*********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

eval("{__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://trendmodenl/./src/styles/sections/opk-search.scss?\n}");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Check if module exists (development only)
/******/ 		if (__webpack_modules__[moduleId] === undefined) {
/******/ 			var e = new Error("Cannot find module '" + moduleId + "'");
/******/ 			e.code = 'MODULE_NOT_FOUND';
/******/ 			throw e;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/scripts/sections/opk-search.js");
/******/ 	
/******/ })()
;